import { colors } from '@agria/theme/src/styles/tokens';

const theme = {
  stacked: false,
  gap: 'medium',
  backgroundSelected: 'brandOne100',
  includeTick: false,
  focusBoxShadow: '0px 0px 0px 2px #FFF, 0px 0px 0px 4px #000',
  focusValidBoxShadow: `${colors.systemFocusValid};`,
  focusInvalidBoxShadow: `${colors.systemFocusInvalid};`,
  includeUnderline: false,
} as const;

export default theme;
